import {CandidateSource, CandidateSourceRestControllerApiFactory,} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const CandidateSourceListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<CandidateSource> = {
		title: "Listado de orígenes de candidatos ",
		onClick: "/app/admin/recruitment/source",
		headers: [
			{title: "Nombre"}
		],
		decorator: (bean: CandidateSource) => (
			< >
				<TableCell style={{color: bean.dismissed ? COLOR_GRIS : ""}}>
					{bean.label}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(CandidateSourceRestControllerApiFactory);
			return ctrl.pageCandidateSource(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};